import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, CardBody, CardImg, CardLink, CardSubtitle, CardText, CardTitle, Col, Container, Fade, Row, Input, CardFooter, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faBook, faTrashAlt, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { LoadingSpinnerModal, ConfirmModal, DABTextBox } from '../../components/dab';
import parse from "html-react-parser";
import { channelAction } from '../../actions/channelAction';
import { languageAction } from '../../actions/languageAction';
import { showAlert } from "../common/functions";
import NoImage from '../../assets/images/noimage.png'

interface IChannelProps {
	dispatch: Dispatch<any>;
	channelData: any;
	languageData: any;
	langcode: any;
}

const ChannelList: React.SFC<IChannelProps> = ({
	dispatch, channelData, languageData, langcode }) => {

	const history = useHistory();
	const initialValue = [{ text: "English", value: "en", checked: false }];

	const initialFilterValues = {
		isActive: true,
		isInActive: true,
		isAllLangSelected: true,
		selectedLanguages: [""]
	};

	const initialChannelInputValue = {
		getActiveOnly: false,
		sortColumn: "sortorder",
		sortDirection: "asc"
	};

	const [isFilter, setFilter] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [selectedId, setSelectedId] = useState(-1);
	const [selectedTitle, setSelectedTitle] = useState("");
	const [inputTitle, setInputTitle] = useState("");
	const [isTitleErr, setIsTitleErr] = useState(false);
	const [channelList, setChannelList] = useState([]);
	const [langList, setLangList] = useState(initialValue);
	const [isLangListLoaded, setIsLangListLoaded] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [isFilterByLanguage, setIsFilterByLanguage] = useState(false);
	const [filterInput, setFilterInput] = useState(initialFilterValues);
	const [channelFilterInput, setChannelFilerInput] = useState(initialChannelInputValue);
	const [isRestore, setIsRestore] = useState(false);

	const handeToggle = () => setFadeIn(!fadeIn);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleShowClearFilter = (input) => {

		if (!input.isActive || !input.isInActive || !input.isAllLangSelected) {
			setShowClearFilter(true);
		}
		else {
			setShowClearFilter(false);
		}
	}

	const handleFilter = (type, value, checked) => {
		var input = filterInput;
		var channelListToFilter = channelData.items;
		var languageList = langList;
		if (type == "status")
		{
			localStorage.removeItem("langCode");
			if (value == "active") {
				input.isActive = checked;
			}
			else {
				input.isInActive = checked;
			}
		}

		if (type === "language")
		{
			if (value == "all")
			{
				localStorage.removeItem("langCode");
				langList.forEach((data) => data.checked = checked);
				setLangList(langList);
				input.isAllLangSelected = checked;
			}
			else
			{
				if (langcode != null && langcode.trim().length != 0) {
					if (langcode != value) {
						localStorage.removeItem("langCode");
					}
					else {
						if (checked == false) {
							localStorage.removeItem("langCode");
						}
					}
				}

				languageList.map((data) =>
				{
					if (data.value.trim().toLowerCase() == value.trim().toLowerCase()) {
						data.checked = checked;
					}
				});
				setLangList(languageList);				
				input.isAllLangSelected = languageList.every((item) => item.checked === true)
			}
		}

		if (type === "restore") {
			languageList.map((data) => {
				if (value.find(ele => ele == data.value)) {
					data.checked = checked;
				}
			});
			setLangList(languageList);
			input.isAllLangSelected = languageList.every((item) => item.checked === true)
		}

		if (!input.isAllLangSelected)
		{
			var selectedLanguages = languageList.filter(x => x.checked == true).map(function (v) {
				return v.value;
			});

			channelListToFilter = channelListToFilter.filter(data => {
				return (
					selectedLanguages.includes(data.languageCode)
				);
			})
		}

		if (input.isActive == false && input.isInActive == false) {
			channelListToFilter = [];
		}
		else if (input.isActive == true && input.isInActive == false) {
			channelListToFilter = channelListToFilter.filter(data => {
				return (
					data.isActive == true
				);
			})
		}
		else if (input.isActive == false && input.isInActive == true) {
			channelListToFilter = channelListToFilter.filter(data => {
				return (
					data.isActive == false
				);
			})
		}

		setFilterInput(input);
		setChannelList(channelListToFilter);

		if (!isFilter)
		{
			setFilter(true);
		}

		handleShowClearFilter(input);
	};

	const handleSelectForDelete = (id: number, title: string) => {
		setSelectedId(id);
		setSelectedTitle(title);
		setInputTitle("");
		setShowDeleteModal(true);
	};


	const handleInputChange = (event) => {
		let value = event.target.value;
		setIsTitleErr(false);
		setInputTitle(value);
	};

	const handleClearFilter = () => {
		localStorage.removeItem("langCode");
		setFadeIn(false);
		var input = filterInput;
		input.isActive = true;
		input.isInActive = true;
		input.isAllLangSelected = true;
		setFilterInput(input);
		setChannelList(channelData.items);

		var list: any[] = [];
		langList.map((data) => {
			var item = { text: data.text, value: data.value, checked: true };
			list.push(item);
		});
		setLangList(list);
		setShowClearFilter(false);
	}


	const handleCloseClick = () => {
		setShowDeleteModal(false);
	}

	const handleLoadDeleteModal = () => {
		if (selectedTitle.toLowerCase() == inputTitle.toLowerCase()) {
			setIsTitleErr(false);
			dispatch(channelAction.channelDelete(selectedId));
			setShowModal(true);
			setShowDeleteModal(false);
		}
		else {
			setIsTitleErr(true);
		}
	};

	if (isFilterByLanguage && isLangListLoaded && channelData.isListSuccess) {
		setIsFilterByLanguage(false);
		handleFilter("language", langcode, true);
	}

	if (!isFilterByLanguage && isLangListLoaded && channelData.isListSuccess) {
		isRestore ?
			handleFilter("restore", filterInput.selectedLanguages, true)
			: handleFilter("language", "all", true);
	}

	if (channelData && !channelData.isLoading && channelData.isListSuccess) {
		channelData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (selectedId >= 0 && channelData.isSuccess
		&& channelData.isDeleteCompleted
		&& !channelData.isError) {
		showAlert(channelData.status, false);
		channelData.isSuccess = false;
		channelData.isDeleteCompleted = false;
		dispatch(channelAction.channelGetByfilter(channelFilterInput));
		setSelectedId(-1);
	}

	if (!channelData.isSuccess && channelData.isError) {
		if (channelData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(channelData.status, true);
		}
		channelData.isError = false;
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	if (langList && !isLangListLoaded && languageData && languageData.items.length > 0) {

		var input = filterInput;
		var langSelect = true;

		if (langcode && langcode.trim() != "") {
			input.isAllLangSelected = false;
			setFilterInput(input);
		}

		if (!input.isAllLangSelected) {
			langSelect = false;
		}
		var list: any[] = [];
		languageData.items.map((data) => {
			var item = {
				text: data.name, value: data.languageCode,
				checked: langcode && data.languageCode === langcode ? true : langSelect
			};
			list.push(item);
		});
		setLangList(list);
		setIsLangListLoaded(true);
		dispatch(channelAction.channelGetByfilter(channelFilterInput));
	}

	const handleDetailNavigation = () => {
		if (initialFilterValues.isActive != filterInput.isActive
			|| initialFilterValues.isInActive != filterInput.isInActive
			|| initialFilterValues.isAllLangSelected != filterInput.isAllLangSelected) {
			var input = filterInput
			var list: any[] = []
			langList.forEach((ele) => {
				if (ele.checked === true)
					list.push(ele.value)
			})
			input.selectedLanguages=list
			sessionStorage.setItem("fromPage", "channel")
			sessionStorage.setItem("chlFilter", JSON.stringify(input));
		}
	}

	React.useEffect(() => {
		dispatch(languageAction.languageGetByfilter());

		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'channel') {
			handleFilterRestore();
		}

		if (langcode) {
			setIsFilterByLanguage(true);
		}
		setShowModal(true);
	}, []);

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("chlFilter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				setFilterInput(filterObj);
				setIsRestore(true);
				sessionStorage.removeItem("fromPage");
				sessionStorage.removeItem("chlFilter");
			}
		}
	}

	const handleListFilter = (channelId:number) => {
		localStorage.setItem("channelId",JSON.stringify(channelId));
	}

	return (
		<div data-testid="channelPage" className="channel-page">
			<div className='card-box'>
				<Col lg="8" className='column'><CardLink onClick={handeToggle} className='card-box-link'>Filter List</CardLink>
				{showClearFilter ?
					<CardLink onClick={handleClearFilter} className='card-box-link-filter'>Clear Filter</CardLink>
						: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}</Col>
				{fadeIn && (
					<Fade in={fadeIn} tag="h5" className='card-fade'>
						<Container className='filter-container'>
							<div className='box-container'>
								<Row>
									<Col lg="2">
										<div>
											<label>Status</label>
											<div className='filterRow'>
												<Input type="checkbox" className='box-container-input' checked={filterInput.isActive}
													onChange={(e) => { handleFilter("status", "active", e.target.checked) }} />
												<span >Active</span>
											</div>
											<div className='filterRow'>
												<Input type="checkbox" className='box-container-input' checked={filterInput.isInActive}
													onChange={(e) => { handleFilter("status", "inactive", e.target.checked) }} />
												<span>Inactive</span>
											</div>
										</div>
									</Col>
									<Col lg="9">
										<label>Languages</label>
										<div>
										<Row xs="4">
												<Col lg="3" key="selectAll" className='filterRow'>
													<Input type="checkbox" className='box-container-input'
														checked={filterInput.isAllLangSelected}
														onChange={(e) => { handleFilter("language", "all", e.target.checked) }}
													/>Select All
												</Col>
										</Row>
										</div>
										<div >
										<Row xs="4">
												{
													langList && langList.map((data: any) =>
														<Col lg="3" key={data.value} className='filterRow'>
															<Input type="checkbox" className='box-container-input'
																name={data.value} checked={data.checked}
																onChange={(e) => { handleFilter("language", data.value, e.target.checked) }} />
															<span >{data.text}</span>
														</Col>
													)}
											</Row>
										</div>
									</Col>
									<Col lg="1">
										<div className='close-div'>
											<FontAwesomeIcon data-bs-toggle="tooltip" data-bs-placement="bottom" size='3x'
												title="Close" icon={faTimes} onClick={handeToggle} />
										</div>
									</Col>
								</Row>
							</div>
						</Container>
					</Fade>)}
			</div>

			<Row xs="3">
				<Col key={0} lg="4">
					<Card className='card-box'>
						<FontAwesomeIcon className='card-box-add-img' data-bs-toggle="tooltip" data-testid="createNewChannel"
							size='10x'
							data-bs-placement="bottom" title="Add Channel" icon={faPlus}
							onClick={() => { window.location.href = "/channel?page=add" }} />
						<CardBody className='card-body-add'>
							<CardTitle tag="h5">
								<CardLink className='card-box-link-title' href={'/channel?page=add'} title='Create Channel'>
									Add New
								</CardLink>
							</CardTitle>
							<CardSubtitle tag="h6" className="mb-2 text-muted"></CardSubtitle>
							<CardText>Add a new Channel</CardText>
						</CardBody>
						<CardFooter className='card-footer'>
							<Row xs="3">
								<Col></Col>
								<Col> </Col>
								<Col> </Col>
							</Row>
						</CardFooter>
					</Card>
				</Col>
				{
					channelData && ((isFilter && channelList) ? channelList :
						channelData.items).map((data: any) =>
						<Col key={data.channelId} lg="4">
							<Card className={data.isActive ? 'card-box' : 'card-box-disabled'} data-testid="channelBody">
								<CardImg className='card-box-img'
									src={data.iconImage}
									alt={data.title}
									onClick={() => { handleDetailNavigation(); window.location.href = "/channel?id=" + data.channelId }}
									onError={(e: any) => { e.target.src = NoImage }}
								/>
								<CardBody className="channel-card-body">
									<CardTitle tag="h5" onClick={handleDetailNavigation}>
										<CardLink className='card-box-link-title' href={'/channel?id=' + data.channelId} title={data.title}>
											{data.title}
										</CardLink>
									</CardTitle>
									<CardText tag="span">{parse(data.descriptionHtml)}</CardText>
								</CardBody>
								<CardFooter className='card-footer'>
									<Row xs="3" key={data.channelId} className='card-footer-row'>
											<Col lg="4" xl="4" xs="4" md="4" className='footer-box'>
												<a onMouseDown={() => handleListFilter(data.channelId)}  href={`/episode`} className="detail-link" data-testid="episodeDetailButton">
													<FontAwesomeIcon className='footer-box-icon' icon={faMicrophone} onClick={handleDetailNavigation}
														data-bs-toggle="tooltip" data-bs-placement="bottom" title="View Episodes" />
												</a>
											</Col>
											<Col lg="4" xl="4" xs="4" md="4" className='footer-box'>
												<a onMouseDown={() => handleListFilter(data.channelId)} href={`/readingplan`} className="detail-link" data-testid="readingPlanButton">
													<FontAwesomeIcon className='footer-box-icon' icon={faBook} onClick={handleDetailNavigation}
														data-bs-toggle="tooltip" data-bs-placement="bottom" title="View Reading plans" />
												</a>
											</Col>
											<Col lg="4" xl="4" xs="4" md="4" className='footer-box-last'>
												<FontAwesomeIcon className='footer-box-icon' icon={faTrashAlt}
													data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete"
													onClick={() => { handleSelectForDelete(data.channelId, data.title); }} data-testid="channelDeleteButton" />
											</Col>
									</Row>
								</CardFooter>
							</Card>
						</Col>
					)}
			</Row>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				)
			}
			<Modal isOpen={showDeleteModal} backdrop="static" centered data-testid="deleteModal">
				<ModalHeader>
					Delete Channel
				</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteChannelsForm">
						<div className={["col-form-label"].join(" ")} data-testid="channelDeleteMessage">Deleting a channel is an irreversible act and will also delete episodes, user-episode data,
						and even channel-specific reading plans. 
						If you truly want to delete this channel, please type the full name of the channel and click Delete.
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="channelTitleText" className={["col-sm-5 col-form-label"].join(" ")}>Type Channel Title</label>
							<div className={["col-sm-6"].join(" ")} data-testid="channelTitleContainer">
								<DABTextBox className={["form-control"].join(" ")} id="title" value={inputTitle} isRequired={true}
									onChange={(event) => { handleInputChange(event) }} isHover={false} />
								<div style={{ display: `${isTitleErr ? '' : 'none'}` }}><label data-testid="TitleErr" className="text-danger">Typed Channel Title Is Incorrect</label></div>
							</div>
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" data-bs-dismiss="modal" onClick={handleCloseClick} data-testid="cancelDeleteButton">Cancel</Button>
					<Button type="button" color="primary" onClick={handleLoadDeleteModal} data-testid="confirmDeleteButton">Confirm Delete</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { channelData, languageData } = state;
	return {
		channelData, languageData
	};
};

export default connect(mapStateToProps)(ChannelList);